import React from "react";
import PropTypes from 'prop-types';
import classes from './Discipline.module.css';
import Card from '../../UI/Card';
import { getClassByNum } from "../../../utils";
import { useSelector } from "react-redux";

const Discipline = ({ baseUrl , backgroundImage, name, recommendedClass, fromClass, toClass, selectDisciplineCB, id, backgroundColor, newFlag,active }) => {
    const texts = useSelector(state => state.translate.texts);

    return <div className={classes.Discipline} onClick={() => selectDisciplineCB(id)}>
        <Card>
            <div className={classes.TopPart} style={{ backgroundImage: `url(${baseUrl}/${backgroundImage}`, backgroundColor: backgroundColor }}>
                {!active && <div className={classes.NoActive}></div>}
            </div>
            <div className={classes.Content}>
                <div className={classes.NameDescriptionWarrper}>
                    <div className={classes.Description}>{name}</div>
                    {!newFlag && <div>
                        <div className={classes.line} />
                        <div className={classes.ClassRecommand}>{texts.recomanded} {getClassByNum(recommendedClass)}</div>
                        <div className={classes.Class}>{texts.suitable} {getClassByNum(fromClass)} - {getClassByNum(toClass)}</div>
                    </div>}

                </div>
            </div>
        </Card>
    </div>
}

Discipline.propTypes = {
    backgroundImage: PropTypes.string,
    name: PropTypes.string,
}

export default Discipline;